import { decryptDataWithRSA } from '@/Utils/cryptoUtils';
import fetchData from '@/Utils/fetchData';
import { REQUEST_TYPE } from '@/constants/request-types';
import store from '@/store';
import { UserWhiteListType } from '@/types/key-exchange';

export const fetchP2PWhiteList = async () => {
    const activeServer = store.getState().serverDataReducer.activeServer;
    const membersList =
        store.getState().serverDataReducer.memberList?.[activeServer];
    const privateKey =
        store.getState().serverDataReducer.serverData?.[activeServer]
            .privateKey;
    const baseUrl = process.env.REACT_APP_BASE_API_URL;
    const link = baseUrl + `/api/v6/white_list?subserver_id=${activeServer}`;
    const request = await fetchData(REQUEST_TYPE.GET, link);

    let response = [];
    let error = false;

    if (request.data?.status) {
        response = request.data.data;
        response = await Promise.all(
            response.map(async (el: UserWhiteListType) => {
                const decryptedUuid = await decryptDataWithRSA(
                    el.device_signed,
                    privateKey,
                );

                const decryptedSign = await decryptDataWithRSA(
                    el.hash_signed as string,
                    privateKey,
                );
                return {
                    ...el,
                    name: membersList[el?.user_id]?.name,
                    username: membersList[el?.user_id]?.username,
                    device_signed: decryptedUuid,
                    hash_signed: decryptedSign,
                };
            }),
        );
    } else {
        error = true;
    }
    return { response, error };
};

export const AddUserToP2PWhiteList = async ({
    uuid,
    hash,
    date,
    user_id,
    subserver,
}) => {
    const baseUrl = process.env.REACT_APP_BASE_API_URL;
    const link = baseUrl + `/api/v6/white_list/save_permit`;

    const body = {
        device_signed: uuid,
        hash_signed: hash,
        valid_until_signed: date,
        user_id: user_id,
        chat_subserver_id: subserver,
    };

    const request = await fetchData(REQUEST_TYPE.POST, link, body);

    let response = null;
    let error = false;

    if (request.data?.status) {
        response = request.data.data;
        error = false;
    } else {
        error = true;
        if (response?.data?.message) {
            response = response.data.message;
        }
    }
    return { response, error };
};
export const AddUsersToP2PWhiteList = async body => {
    const baseUrl = process.env.REACT_APP_BASE_API_URL;
    const link = baseUrl + `/api/v6/white_list/save_all`;

    const request = await fetchData(REQUEST_TYPE.POST, link, body);

    let response = null;
    let error = false;

    if (request.data?.status) {
        response = request.data.data;
        error = false;
    } else {
        error = true;
        if (response?.data?.message) {
            response = response.data.message;
        }
    }
    return { response, error };
};
export const rejectUserFromP2PWhiteList = async ({
    uuid,
    hash,
    date,
    user_id,
    subserver,
}) => {
    const baseUrl = process.env.REACT_APP_BASE_API_URL;
    const link = baseUrl + `/api/v6/white_list/reject_device`;

    const body = {
        device_signed: uuid,
        hash_signed: hash,
        valid_until_signed: date,
        user_id: user_id,
        chat_subserver_id: subserver,
    };

    const request = await fetchData(REQUEST_TYPE.POST, link, body);

    let response = null;
    let error = false;

    if (request.data?.status) {
        response = request.data.data;
        error = false;
    } else {
        error = true;
        if (response?.data?.message) {
            response = response.data.message;
        }
    }
    return { response, error };
};
export const rejectUsersFromP2PWhiteList = async body => {
    const baseUrl = process.env.REACT_APP_BASE_API_URL;
    const link = baseUrl + `/api/v6/white_list/reject_all`;

    const request = await fetchData(REQUEST_TYPE.POST, link, body);

    let response = null;
    let error = false;

    if (request.data?.status) {
        response = request.data.data;
        error = false;
    } else {
        error = true;
        if (response?.data?.message) {
            response = response.data.message;
        }
    }
    return { response, error };
};

export const deleteUserFromWhiteList = async ({ permit_id }) => {
    const activeServer = store.getState().serverDataReducer.activeServer;

    const baseUrl = process.env.REACT_APP_BASE_API_URL;
    const link = baseUrl + `/api/v6/white_list/revoke_permit`;

    const body = {
        id: permit_id,
        chat_subserver_id: activeServer,
    };

    const request = await fetchData(REQUEST_TYPE.POST, link, body);

    let response = null;
    let error = false;

    if (request.data?.status) {
        response = request.data.message;
    } else {
        error = true;
        if (response?.data?.message) {
            response = response.data.message;
        }
    }

    return { response, error };
};
